import { render, staticRenderFns } from "./shift-view-conformation.vue?vue&type=template&id=107bace2&scoped=true"
import script from "./shift-view-conformation.vue?vue&type=script&lang=js"
export * from "./shift-view-conformation.vue?vue&type=script&lang=js"
import style0 from "./shift-view-conformation.vue?vue&type=style&index=0&id=107bace2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107bace2",
  null
  
)

export default component.exports